import { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon
  const [viewAs, setViewAs] = useState(null); // admin "view as" role override

  useEffect(() => {
    const token = localStorage.getItem("carle_token");
    if (!token) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        localStorage.removeItem("carle_token");
        setUser(false);
      });
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("carle_token", data.token);
    setUser(data.user);
    setViewAs(null);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("carle_token");
    setUser(false);
    setViewAs(null);
  };

  const effectiveRole = user && user.role === "it_admin" && viewAs ? viewAs : user?.role;

  return (
    <AuthContext.Provider value={{ user, login, logout, viewAs, setViewAs, effectiveRole }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
